module.exports = __webpack_public_path__ + "static/media/cross-icon.bf2628e4.png";